

function getPrice() {

    let bookPrice     = 29.8,
        deliveryPrice = 3,
        higherDeliveryPrice = 6,
        count          = document.getElementById('input-count').value,
        priceContainer = document.getElementById('price-full'),
        deliveryPriceContainer = document.getElementById('price-delivery'),
        price

// IF 1 BOOK, ADD FIX PRICE
    if( count <= 1 ) {
        price = bookPrice + deliveryPrice
        deliveryPriceContainer.innerText = deliveryPrice

    } else {
        price = bookPrice * count + higherDeliveryPrice
        deliveryPriceContainer.innerText = higherDeliveryPrice
    }


// REPLACE CURRENCY DISPLAY
    price = price.toString().replace('.', ',')

// ADD SECOND 0 IF NECESSARY
    if( price.length - price.indexOf(',') == 2 )
        price += '0'

// CHECK IF MORE THAN TWO DECIMALS
    if( price.indexOf(',') > 2 ) {

        let commaPosition = price.indexOf(','),
            dump          = price.substr(commaPosition + 3, price.length)

        price = price.replace(dump, '')

    }

    priceContainer.innerText = price

}

getPrice()

function updatePrice() {

    let countInput = document.getElementById('input-count')

    countInput.addEventListener('keyup', () => getPrice())
    countInput.addEventListener('mouseup', () => getPrice())

}

updatePrice()



// WEBPACK FOOTER //
// ./src/js/modules/calc.js